<script>
  export let value=90;
  const repeat = (times, fn) => {
    let result = '';
    for(let index = 0; index<times; index++ ){
      result += fn(index);
    }
    return result;
  };
  let dynamicStyle = '' +
  '--height: 30px;' +
  '--thumb-height: 13px;' +
  '--track-height: 3px;' +
  '--thumb-track-divided-by-2: -5px;' + /* (thumb-height - track-height) / 2 */
  '--thumb-height-divided-by-2: -6px;' + /* thumb-height / 2 */
  '--upper-color: #cfcfcf;' +
  '--lower-color: #0199ff;' +
  '--thumb-color: #0199ff;' +
  '--thumb-hover-color: #55c2ff;' +
  /* ${index}px 0 0 -(($thumb-height - $track-height) / 2)px #${upper-color}; */
  '--box-shadow: ' + repeat(999, index => `${index}px 0 0 -5px #cfcfcf, `) +
  '1000px 0 0 -5px #cfcfcf;';

</script>

<input class="e-range" type="range" min="0" max="100" step="5" bind:value={value} style={dynamicStyle}>

<style>
  /* excess height to improve interactive area / accessibility */

  /* Webkit cannot style progress so we fake it with a long shadow
 on the thumb element */
/* @function webkit-slider-thumb-shadow($i: 1) {
  $val: #{$i}px 0 0 -#{($thumb-height - $track-height) / 2} #{$upper-color};
  @if $i == 1 {
    @for $k from 2 through 1000 {
      $val: #{$val}, webkit-slider-thumb-shadow($k);
    }
  }
  @return $val;
} */

.e-range {
  /* --height: 30px;
  --thumb-height: 13px;
  --track-height: 3px;
  --thumb-track-divided-by-2: -5px; /* (thumb-height - track-heigh) / 2 */
  /* --thumb-height-divided-by-2: -6px; */

  /* colours */
  /* --upper-color: #cfcfcf;
  --lower-color: #0199ff;
  --thumb-color: #0199ff;
  --thumb-hover-color: #55c2ff; */

  --upper-background: linear-gradient(to bottom, var(--upper-color), var(--upper-color)) 100% 50% / 100% var(--track-height) no-repeat transparent;
  --lower-background: linear-gradient(to bottom, var(--lower-color), var(--lower-color)) 100% 50% / 100% var(--track-height) no-repeat transparent;

  display: block;
  appearance: none;
  width: 100%;
  margin: 0;
  height: var(--height);
  overflow: hidden;
  cursor: pointer;
  background: transparent;  
}

.e-range:focus {
  outline: none;
}

/* Webkit */
.e-range::-webkit-slider-runnable-track {
  width: 100%;
  height: var(--height);
  background: var(--lower-background);
}

.e-range::-webkit-slider-thumb {
  position: relative;
  appearance: none;
  height: var(--thumb-height);
  width: var(--thumb-height);
  background: var(--thumb-color);
  border-radius: 100%;
  border: 0;
  top: 50%;
  margin-top: var(--thumb-height-divided-by-2);
  /* box-shadow: webkit-slider-thumb-shadow(); */
  transition: background-color 150ms;
  box-shadow:  var(--box-shadow);
}

 /* Firefox */
.e-range::-moz-range-track,
.e-range::-moz-range-progress {
  width: 100%;
  height: var(--height);
  background: var(--upper-background);
}

.e-range::-moz-range-progress {
  background: var(--lower-background);
}

.e-range::-moz-range-thumb {
  appearance: none;
  margin: 0;
  height: var(--thumb-height);
  width: var(--thumb-height);
  background: var(--thumb-color);
  border-radius: 100%;
  border: 0;
  transition: background-color 150ms;
}

 /* Internet Explorer */
.e-range::-ms-track {
  width: 100%;
  height: var(--height);
  border: 0;
   /* color needed to hide track marks */
  color: transparent;
  background: transparent;
}

.e-range::-ms-fill-lower {
  background: var(--lower-background);
}

.e-range::-ms-fill-upper {
  background: var(--upper-background);
}

.e-range::-ms-thumb {
  appearance: none;
  height: var(--thumb-height);
  width: var(--thumb-height);
  background: var(--thumb-color);
  border-radius: 100%;
  border: 0;
  transition: background-color 150ms;
   /* IE Edge thinks it can support -webkit prefixes */
  top: 0;
  margin: 0;
  box-shadow: none;
}

.e-range:hover::-webkit-slider-thumb {
  background-color: var(--thumb-hover-color);
}
.e-range:hover::-moz-range-thumb {
  background-color: var(--thumb-hover-color);
}
.e-range:hover::-ms-thumb {
  background-color: var(--thumb-hover-color);
}
.e-range:focus::-webkit-slider-thumb {
  background-color: var(--thumb-hover-color);
}
.e-range:focus::-moz-range-thumb {
  background-color: var(--thumb-hover-color);
}
.e-range:focus::-ms-thumb {
  background-color: var(--thumb-hover-color);
}
</style>
